import { useCallback } from "react";
import { useTokenListByChain } from "./useTokenListByChain";
import { getTokenDecimals } from "../utils/tokenUtils";
import { Hash } from "viem";

export const useGetTokenDecimals = () => {
  const tokenList = useTokenListByChain();
  return useCallback(
    (tokenAddress: Hash) => getTokenDecimals(tokenAddress, tokenList),
    [tokenList]
  );
};
